import type { MapDef } from './MapDef.js';
import { CANYON } from './canyon.js';
import { CRUCIBLE } from './crucible.js';
import { FOUNDRY } from './foundry.js';
import { VAULT } from './vault.js';

// V1.5 maps registry. Add a new map here, then expose it from index.ts
// (root) and (optionally) from a UI picker. `MAPS[id]` is the canonical
// runtime lookup — Simulation, CampSystem, Renderer, and the Minimap all
// resolve their map through this registry rather than hard-coding FOUNDRY.

export type MapId = 'foundry' | 'vault' | 'canyon' | 'crucible';

export const MAPS: Readonly<Record<MapId, MapDef>> = Object.freeze({
  foundry: FOUNDRY,
  vault: VAULT,
  canyon: CANYON,
  crucible: CRUCIBLE,
});

// Player-facing default map. Crucible is the flagship 3000×2400 7-relay map
// and is the level new players land on from the main menu. The MATCH_CONFIG_*
// constants in data/matchConfig.ts still pin mapId: 'foundry' for backwards
// compatibility with the V0.x/V1.5 test suites (which hard-code Foundry's
// 3-relay geometry), so changing this constant does not retroactively flip
// any test fixture — it only affects callers that construct a sim with no
// mapId set, which is how the client + server now boot.
export const DEFAULT_MAP_ID: MapId = 'crucible';

export function getMap(id: MapId): MapDef {
  return MAPS[id];
}

export const MAP_IDS: readonly MapId[] = ['foundry', 'vault', 'canyon', 'crucible'];
